import { InjectionToken } from '@angular/core';
import {
  ApiScenarioListResponseDto,
  ApiScenarioOperationResponseDto,
  ApiScenarioHistoryListResponseDto,
} from '@birco/rainmesh-api';
import { Observable } from 'rxjs';
import { ScenarioHistoryFilter } from '../../../features/scenarios/state/scenario.state';

export interface ScenarioStateService {
  getScenarios(): Observable<ApiScenarioListResponseDto>;

  getScenarioHistory(
    options: ScenarioHistoryFilter,
  ): Observable<ApiScenarioHistoryListResponseDto>;

  runScenario(id: string): Observable<ApiScenarioOperationResponseDto>;

  stopScenario(id: string): Observable<ApiScenarioOperationResponseDto>;
}

export const SCENARIO_STATE_SERVICE_INJECTION_TOKEN =
  new InjectionToken<ScenarioStateService>('ScenarioStateService');
